exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "nav[data-v-8a8de2f0] {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-pack: justify;\n          justify-content: space-between;\n}\nnav .datatable_sort_wrapper[data-v-8a8de2f0] {\n  position: relative;\n}\nnav .datatable_sort_wrapper .sort_icon[data-v-8a8de2f0] {\n  position: absolute;\n  line-height: 0;\n  right: 0.25em;\n  top: calc(50% - .5em);\n  color: #adb5bd;\n}\nnav .datatable_sort_wrapper .sort_icon.active[data-v-8a8de2f0] {\n  color: #000;\n}\nnav .per_page select[data-v-8a8de2f0] {\n  display: inline-block;\n  width: auto;\n}", ""]);

// exports
